export const SHOW_PRODUCT = "showproduct";
export const DELETE_PRODUCT = "productdelete";
export const UPDATE_PRODUCT = "productupdate";
export const SINGLE_PRODUCT = "productsowone";
export const ADMIN_PRODUCT = "adminproduct";




export const ADMIN_ADD_PRODUCT = "adminaddproduct";

export const ADMIN_GET_ALL_USER = "admin/get/all/user";
export const ADMIN_DELETE_USER = "admin/delete/user";